<template>
  <div class="my-card">
    <router-link :to="{name: 'PsicologoProfile', params: {id: id}}" class="text-center">
      <v-avatar size="120">
        <v-img :src="img"></v-img>
      </v-avatar>
      <p class="text--my-card text-center">{{ name }}</p>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    img: String,
    name: String,
    id: Number,
  },
};
</script>

<style lang="scss" scoped>
    .my-card {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        // width: 260px;
        min-height: 200px;
        padding: 10px;
        background-color: var(--v-gray-lighten5);
        border-radius: 8px;

        a {
            text-decoration: none;
        }
    }
    .text--my-card {
        margin: 10px 0;
        padding: 8px 25px;
        border-radius: 20px;
        background-color: var(--v-white-base);
    }
</style>
